import api from './api'

export const earlyRegistrationService = {
  getRegistrations: async (params) => {
    const { data } = await api.get('/early-registration/admin', { params })
    return data
  }
}
